let ENV = 'product'

// 返回服务接口地址
export const filterBaseUrl = (serviceName = '') => {
  let serviceUrl
  const origin = /^http[s]?:\/\/([^/:]+)/.exec(window.location.href)
  if (Array.isArray(origin) && origin.length > 1) {
    const uriMap = [
      // 施工平台
      { origin: 'geip-fat', zjy: 'https://zjy-dev.glodon.com', cost: 'https://digital-cost-test.glodon.com', env: 'test' },
      { origin: 'aecloud-test', zjy: 'https://zjy-pre.glodon.com', cost: 'https://digital-cost-pre.glodon.com', env: 'pre' },
      { origin: 'geip-pre', zjy: 'https://zjy-pre.glodon.com', cost: 'https://digital-cost-pre.glodon.com', env: 'pre' },
      { origin: 'geip', zjy: 'https://zjy.glodon.com', cost: 'https://digital-cost.glodon.com', env: 'product' },
      { origin: 'xmgl', zjy: 'https://zjy.glodon.com', cost: 'https://digital-cost.glodon.com', env: 'product' },
      // 成本平台
      { origin: 'dcost-dev', sub: 'https://dcost-sub-dev.glodon.com', zjy: 'https://zjy-dev.glodon.com', cost: 'https://digital-cost-dev.glodon.com', env: 'test' },
      { origin: 'dcost-stg', sub: 'https://dcost-sub-dev.glodon.com', zjy: 'https://zjytest.glodon.com', cost: 'https://digital-cost-stg.glodon.com', env: 'test' },
      { origin: 'dcost-test', sub: 'https://dcost-sub-inner.glodon.com', zjy: 'https://zjytest.glodon.com', cost: 'https://digital-cost-test.glodon.com', env: 'test' },
      { origin: 'dcost-pre', sub: 'https://dcost-sub-pre.glodon.com', zjy: 'https://zjy-pre.glodon.com', cost: 'https://digital-cost-pre.glodon.com', env: 'pre' },
      { origin: 'dcost', sub: 'https://dcost-sub.glodon.com', zjy: 'https://zjy.glodon.com', cost: 'https://digital-cost.glodon.com', env: 'product' },
      // 本地环境
      { origin: 'localhost', sub: 'https://dcost-sub-dev.glodon.com', zjy: 'https://zjy-dev.glodon.com', cost: 'https://digital-cost-test.glodon.com', env: 'test' }
      // 强涛环境
      // { origin: 'localhost', zjy: 'https://zjy-dev.glodon.com', cost: 'http://10.2.32.139:8080' }
    ]
    for (let i = 0; i < uriMap.length; i++) {
      if (new RegExp('^' + uriMap[i].origin).test(origin[1])) {
        serviceUrl = uriMap[i][serviceName]
        ENV = uriMap[i].env
        break
      }
    }
  }
  return serviceUrl
}

// 埋点产品码
export const pcode = window.location.host === 'dcost.glodon.com' ? '120766' : '120770'

export const env = ENV

// 造价云接口地址
export const backendUrl = process.env.VUE_APP_BACKEND_BASE_URL || filterBaseUrl('zjy')

// 数字信息成本平台接口地址
export const dcostUrl = process.env.VUE_APP_DIGITAL_BASE_URL || filterBaseUrl('cost')

// 部件产品接口地址
export const subUrl = process.env.VUE_APP_SUB_BASE_URL || filterBaseUrl('sub')

// 用户中心
export const accountUrl = process.env.VUE_APP_ACCOUNT_BASE_URL || filterBaseUrl('account')

// 数字项目管理平台接口地址
export const geipUrl = process.env.VUE_APP_GEIP_BASE_URL || filterBaseUrl('geip') || `${window.location.protocol}//${window.location.host}`

// 单点登录重定向地址
export const redirectUrl = (ticket = '', from = '', productCode = '', webUrl = '') => {
  if (ticket && productCode && webUrl) {
    return `${backendUrl}/backend/cas/webImplicitLogin.do?ticket=${ticket}&from=${from}&productCode=${productCode}&webUrl=${encodeURIComponent(webUrl)}`
  }
  return backendUrl
}
